import { render, staticRenderFns } from "./ModalRegister.vue?vue&type=template&id=725a1313&"
import script from "./ModalRegister.vue?vue&type=script&lang=js&"
export * from "./ModalRegister.vue?vue&type=script&lang=js&"
import style0 from "./ModalRegister.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports